export const MENU_LOGISTIQUE_TECHNIQUE = 'sidebar.logistique.logistiqueTech';
export const MENU_LOGISTIQUE_PARAMETRAGE = 'sidebar.logistique.parametrage';
export const SOUS_MENU_TECHNICIEN = 'sidebar.logistique.technicien';
export const SOUS_MENU_PROJET = 'sidebar.logistique.projets';
export const MENU_AUDIT_TECHNIQUE = 'sidebar.logistique.audit';
export const MENU_DEMANDE_IMPRESSION = 'sidebar.logistique.demandeImpression';
export const SOUS_MENU_EXPEDITION = 'sidebar.logistique.expedition';
export const SOUS_MENU_OT_IMPRESSION = 'sidebar.logistique.ordreTravailImpression';
export const MENU_SUIVI_PRODUCTION = 'sidebar.logistique.suiviProduction';
